'use strict';

window.jQuery = require('jquery');
window.$ = require('jquery');

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/searchModal'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('base/components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./components/countrySelector'));
    processInclude(require('./components/geoLocationPopup'));
    processInclude(require('./components/passwordRequirementHelper'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('app_plugin_salesforcepayments/components/express'));
    processInclude(require('./search/dynamicTileData'));
});

require('slick-carousel/slick/slick.min.js');
require('./thirdParty/bootstrap');
require('base/components/spinner');
